import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes, ExtraOptions, PreloadAllModules } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { slideInAnimation } from './shared/components/transacciones/router-animations';

/***COMPONENTES ***/
import { AuthComponent } from './authentication/auth.component';
import { authGuard } from './authentication/auth.guard';
import { PermisosGuard } from './application/shared/permisos.guard';
import { ValidacionTokenComponent } from './validacion-token/validacion-token.component';
import { LayoutComponent } from "./layout/layout.component";
import { LenderListComponent } from './lender/list/lender-list.component';
import { ProductosNvoListComponent } from './catalogos/productos/lista/productos-nvo-list.component';
import { ProductosNvoEditarComponent } from './catalogos/productos/editar/productos-editar.component';
import { ConceptosProductosComponent } from './catalogos/conceptos-productos/lista/conceptos-productos-list.component';
import { ConceptosProductosNvoComponent } from './catalogos/conceptos-productos/nuevo/conceptos-productos.component';
import { SucursalesComponent } from './catalogos/sucursales/list/sucursales-list.component';
import { SucursalesModificarComponent } from './catalogos/sucursales/modificar/sucursales-modificar.component';
import { DashboardMainComponent } from './dashboard-main/dashboard-main.component';
import { ChecklistsComponent } from './catalogos/checklists/lista/checklists.component';
import { ChecklistsEditarComponent } from './catalogos/checklists/edicion/checklists-editar.component';
import { ConfigCuestionarioComponent } from './catalogos/checklists/modales/configuracion/config-cuestionario.component';
import { ChecklistsFormatoComponent } from './catalogos/checklists/formato/checklists-formato.component';
import { FormatoCuentaComponent } from './catalogos/checklists/formato-cuenta/formato-cuenta.component';
import { PlantillaFirmaDigitalComponent } from './catalogos/checklists/plantilla-firma-digital/plantilla-firma-digital.component';
import { PlantillaFirmaDigitalFormComponent } from './catalogos/checklists/plantilla-firma-digital/form/plantilla-firma-digital-form.component';
import { UsuariosComponent } from './catalogos/usuarios/usuarios.component';
import { UsuariosFormComponent } from './catalogos/usuarios/usuarios-form/usuarios-form.component';
import { AdmistradorSucursalesModificarComponent } from './catalogos/usuarios/sucursales/sucursales-modificar.component';
import { AdmistradorProductosModificarComponent } from './catalogos/usuarios/productos/productos-modificar.component';
import { CatalogoEtiquetasVisitasComponent } from './catalogos/etiquetas-visitas/lista/etiquetas-visitas.component';
import { EtiquetasVisitasFormComponent } from './catalogos/etiquetas-visitas/etiquetas-visitas-form/etiquetas-visitas-form.component';
import { CalificadasVisitasComponent } from './calificadas-visitas/calificadas-visitas.component';
import { HomeComponent as ImportHomeComponent } from './import/home/home.component';
import { ProductComponent as ImportProductComponent } from './import/product/product.component';
import { WizardComponent as ImportWizardComponent } from './import/wizard/wizard.component';
import { FinishComponent as ImportFinishComponent } from './import/finish/finish.component';
import { AccountListComponent } from './account/account-list.component';
import { AccountDetailComponent } from './account/account-detail.component';
import { ClientesMovimientosComponent } from './saldos/clientes-movimientos/clientes-movimientos.component';
import { ClientesMovimientosFormComponent } from './saldos/clientes-movimientos/clientes-movimientos-form/clientes-movimientos-form.component';
import { CobradoresMovimientosComponent } from './saldos/cobradores-movimientos/cobradores-movimientos.component';
import { CobradoresMovimientosFormComponent } from './saldos/cobradores-movimientos/cobradores-movimientos-form/cobradores-movimientos-form.component';
import { ProductosComponent } from './catalogos/permisos-producto/lista/productos-list.component';
import { ProductosModificarComponent } from './catalogos/permisos-producto/editar/productos-modificar.component';
import { ListaTarifaComponent } from './catalogos/tarifas-agentes/lista-tarifa/lista-tarifa.component';
import { TarifaProductosComponent } from './catalogos/tarifas-agentes/editar-tarifa/editar-tarifa.component';
import { PaquetesSaldosComponent } from './catalogos/paquetes-saldos/paquetes-saldos.component';
import { PaquetesSaldosConceptosComponent } from './catalogos/paquetes-saldos-conceptos/paquetes-saldos-conceptos.component';
import { ConceptosSaldosComponent } from './saldos/conceptos-saldos/conceptos-saldos.component';
import { ConceptosSaldosFormComponent } from './saldos/conceptos-saldos/conceptos-saldos-form/conceptos-saldos-form.component';
import { CobradoresFacturacionesPeriodosComponent } from './saldos/cobradores-facturaciones-periodos/cobradores-facturaciones-periodos.component';
import { CobradoresFacturacionesPeriodosFormComponent } from './saldos/cobradores-facturaciones-periodos/cobradores-facturaciones-periodos-form/cobradores-facturaciones-periodos-form.component';
import { PaquetesFinancieraComponent } from './saldos/paquetes-financiera/paquetes-financiera.component';
import { LenderDetailComponent } from './lender/detail/detail.component';
import { PaquetesFinancieraDetalleComponent } from './saldos/paquetes-financiera/paquetes-financiera-detalle/paquetes-financiera-detalle.component';
import { VisitListComponent } from "./visit/visit-list.component";
import { VisitDetailComponent } from "./visit/visit-detail.component";
import { ClientesEtiquetasVisitasComponent } from "./catalogos/clientes-etiquetas-visitas/lista/clientes-etiquetas-visitas.component";
import { ClientesEtiquetasVisitasFormComponent } from "./catalogos/clientes-etiquetas-visitas/form/clientes-etiquetas-visitas-form.component";
import { EstrategiasCampaniaComponent } from './visit/estrategias-campania/estrategias-campania.component';
import { CatalogoPlantillasCampaniasComponent } from './visit/estrategias-campania/components/catalogo-plantillas-campanias/catalogo-plantillas-campanias.component';
import { DescargasComponent } from './descargas/descargas.component';
import { AgentListComponent } from "./agent/agent-list/agent-list.component";
import { AgentDetailComponent } from './agent/agent-detail/agent-detail.component';
import { IndicatorsComponent } from './indicators/indicators.component';
import { GeoCercaCrearComponent } from './geo-cercas/geo-cerca-create/geo-cerca-create.component';
import { LenderNewComponent } from 'src/app/lender/new/new.component';
import { OnboardingComponent } from 'src/app/lender/onboarding/onboarding.component';
import { CalificarObligatoriosComponent } from './calificar-obligatorios/calificar-obligatorios.component';
import { AgenteNuevoComponent } from '@agent/agente-nuevo/agente-nuevo.component';
import { VisitCreateComponent } from './visit-create/visit-create.component';
import { AgenteRecorridoComponent } from './agent/agente-recorridos/agente-recorrido.component';
import { AgenteUbicacionComponent } from './agent/agente-ubicacion/agente-ubicacion.component';
import { PromesasPagoComponent } from './promesas-pago/promesas-pago.component';
import { CashCollectedComponent } from './cash-collected/cash-collected.component';
import { InformacionRecopiladaComponent } from "./visit/informacion-recopilada/informacion-recopilada.component";
import { RevisitListComponent } from "./visit/revisita/revisita-lista.component";
import { RequestListComponent } from './credit-request/request-list.component';
import { UserEditComponent } from './user/edit/user-edit.component';
import { EncargadosFinancieraComponent } from './lender/encargados-financiera/encargados-financiera.component';
import { ListaVisibilidadComponent } from './agent/visibilidad-cuentas/lista/lista-visibilidad.component';
import { ConceptosEtiquetasVisitasComponent } from './saldos/conceptos-etiquetas-visitas/conceptos-etiquetas-visitas.component';
import { ConceptosEtiquetasVisitasFormComponent } from './saldos/conceptos-etiquetas-visitas/conceptos-etiquetas-visitas-form/conceptos-etiquetas-visitas-form.component';
import { CreditRequestComponent } from './credit-request/credit-request.component';
import { CobradoresFacturacionesComponent } from './saldos/cobradores-facturaciones/cobradores-facturaciones.component';
import { ConfigurationComponent } from '@lender/configuration/configuration.component';
import { PaquetesClientesConfigurationComponent } from './saldos/paquetes-financiera/configuration/configuration.component';
import { CuentasAgrupadasListComponent } from './cuentas/cuentas-agrupadas/cuentas-agrupadas-list.component';
import { LayoutFieldsComponent } from 'src/app/lender/layout-fields/layout-fields.component';
import { LayoutFieldNuevo } from '@lender/layout-fields/nuevo/layout-field-nuevo.component';
import { ListadoBloquesComponent } from './catalogos/checklists/formato/bloques/lista/listado-bloques.component';
import { BloqueNuevoComponent } from './catalogos/checklists/formato/bloques/nuevo/bloque-nuevo.component';
import { TutorialesComponent } from './catalogos/tutoriales/tutoriales.component';
import { TutorialesEditarComponent } from './catalogos/tutoriales/tutoriales-editar/tutoriales-editar.component';
import { CriteriosCalidadComponent } from './visitas-criterios/criterios-calidad/criterios-calidad.component';
import { CriteriosCalidadNuevoComponent } from './visitas-criterios/criterios-calidad-nuevo/criterios-calidad-nuevo.component';
import { AjusteMovimientoAgentesComponent } from './saldos/ajuste-movimiento-agentes/ajuste-movimiento-agentes.component';
import { AjusteMovimientoAgentesNuevoComponent } from './saldos/ajuste-movimiento-agentes/ajuste-movimiento-agentes-nuevo/ajuste-movimiento-agentes-nuevo.component';
import { CuentasCampaignsComponent } from './cuentas/cuentas-campañas/cuentas-campaigns.component';
import { SeguimientoIntegralComponent } from './cuentas/seguimiento-integral/seguimiento-integral.component';
import { EsquemaPagoAgentesComponent } from './esquema-pago-agentes/esquema-pago-agentes.component';
import { CentrosCostosComponent } from './saldos/paquetes-financiera/centros-costos/centros-costos.component';
import { NewAccountComponent } from './account/new/new-account.component';
import { ZonasPagoComponent } from './catalogos/zonas-pago/zonas-pago.component';
import { ZonaPagoFormComponent } from './catalogos/zonas-pago/zona-pago-form/zona-pago-form.component';
import { ZonaPagoGeocercasComponent } from './catalogos/zonas-pago/zona-pago-geocercas/zona-pago-geocercas.component';
import { ZonasPagoConfiguracionComponent } from './catalogos/zonas-pago/zonas-pago-configuracion/zonas-pago-configuracion.component';
import { MapaCoberturaComponent } from './cobertura/mapa-cobertura/mapa-cobertura.component';


const routes: Routes = [
  { path: 'auth', component: AuthComponent },
  { path: 'login', loadComponent: () => import('./validacion-token/validacion-token.component').then(m => m.ValidacionTokenComponent) },
  {
    path: '', component: LayoutComponent, canActivate: [authGuard],
    children: [
      {
        path: '', loadComponent: () => import('./dashboard-main/dashboard-main.component').then(m => m.DashboardMainComponent), children: [
        ]
      },
      {
        path: 'geocercas', loadComponent: () => import('./geo-cercas/geo-cerca-create/geo-cerca-create.component').then(m => m.GeoCercaCrearComponent), data: { breadcrumb: 'Geocercas' }, canActivate: [PermisosGuard], children: [
          /*{ path: 'nuevo', loadComponent: () => import('./catalogos/productos/editar/productos-editar.component').then(m => m.ProductosNvoEditarComponent), data:{breadcrumb: 'Nuevo'} },
          { path: 'editar', loadComponent: () => import('./catalogos/productos/editar/productos-editar.component').then(m => m.ProductosNvoEditarComponent), data:{breadcrumb: 'Editar'} }*/
        ]
      },
      {
        path: 'zonas-pago', loadComponent: () => import('./catalogos/zonas-pago/zonas-pago.component').then(m => m.ZonasPagoComponent), data: { breadcrumb: 'Zonas de Pago' }, canActivate: [PermisosGuard], children: [
          { path: 'nueva',                  loadComponent: () => import('./catalogos/zonas-pago/zona-pago-form/zona-pago-form.component').then(m => m.ZonaPagoFormComponent),           data: { breadcrumb: 'Nueva' } },
          { path: 'editar',                 loadComponent: () => import('./catalogos/zonas-pago/zona-pago-form/zona-pago-form.component').then(m => m.ZonaPagoFormComponent),           data: { breadcrumb: 'Editar' } },
          { path: 'geocercas',              loadComponent: () => import('./catalogos/zonas-pago/zona-pago-geocercas/zona-pago-geocercas.component').then(m => m.ZonaPagoGeocercasComponent),      data: { breadcrumb: 'Geocercas' } },
          { path: 'configuracion-clientes', loadComponent: () => import('./catalogos/zonas-pago/zonas-pago-configuracion/zonas-pago-configuracion.component').then(m => m.ZonasPagoConfiguracionComponent), data: { breadcrumb: 'Configuración Clientes' } }
        ]
      },
      {
        path: 'clientes', loadComponent: () => import('./lender/list/lender-list.component').then(m => m.LenderListComponent), data: { breadcrumb: 'Clientes' }, canActivate: [PermisosGuard], children: [
          { path: 'nuevo', loadComponent: () => import('src/app/lender/new/new.component').then(m => m.LenderNewComponent), data: { breadcrumb: 'Nuevo cliente' } },
          { path: 'configuracion', loadComponent: () => import('@lender/configuration/configuration.component').then(m => m.ConfigurationComponent), data:{breadcrumb: 'Configuraciones'} },
          { path: 'encargados', loadComponent: () => import('./lender/encargados-financiera/encargados-financiera.component').then(m => m.EncargadosFinancieraComponent), data:{breadcrumb: 'Encargados'} },
          {
            path: 'onboarding',
            loadComponent: () => import('src/app/lender/onboarding/onboarding.component').then(m => m.OnboardingComponent),
            data: { breadcrumb: 'Onboarding' },
            children: [
              {
                path: 'editar',
                loadComponent: () => import('./catalogos/checklists/edicion/checklists-editar.component').then(m => m.ChecklistsEditarComponent),
                data: { breadcrumb: 'Editar: :nombreCliente/:nombreCheckList' }
              },
              {
                path: 'configuracion',
                loadComponent: () => import('./catalogos/checklists/modales/configuracion/config-cuestionario.component').then(m => m.ConfigCuestionarioComponent),
                data: { breadcrumb: 'Configuración: :nombreCliente/:nombreCheckList' }
              },
              {
                path: 'formato-visita',
                loadComponent: () => import('./catalogos/checklists/formato/checklists-formato.component').then(m => m.ChecklistsFormatoComponent),
                data: { breadcrumb: 'Plantillas visitas: :nombreCliente/:nombreCheckList' },
                children: [
                  {
                    path: 'bloques',
                    loadComponent: () => import('./catalogos/checklists/formato/bloques/lista/listado-bloques.component').then(m => m.ListadoBloquesComponent),
                    data: { breadcrumb: 'Bloques' },
                    children: [
                      {
                        path: 'nuevo',
                        loadComponent: () => import('./catalogos/checklists/formato/bloques/nuevo/bloque-nuevo.component').then(m => m.BloqueNuevoComponent),
                        data: { breadcrumb: 'Nuevo' }
                      },
                      {
                        path: 'editar',
                        loadComponent: () => import('./catalogos/checklists/formato/bloques/nuevo/bloque-nuevo.component').then(m => m.BloqueNuevoComponent),
                        data: { breadcrumb: 'Editar' }
                      }
                    ]
                  }
                ]
              },
              {
                path: 'formato-cuenta',
                loadComponent: () => import('./catalogos/checklists/formato-cuenta/formato-cuenta.component').then(m => m.FormatoCuentaComponent),
                data: { breadcrumb: 'Plantillas cuentas: :nombreCliente/:nombreCheckList' }
              },
              {
                path: 'layout',
                loadComponent: () => import('src/app/lender/layout-fields/layout-fields.component').then(m => m.LayoutFieldsComponent),
                data: { breadcrumb: 'Layout: :nombreCliente/:nombreCheckList' },
                children: [
                  {
                    path: 'nuevo',
                    loadComponent: () => import('@lender/layout-fields/nuevo/layout-field-nuevo.component').then(m => m.LayoutFieldNuevo),
                    data: { breadcrumb: 'Nuevo' }
                  }
                ]
              },
              {
                path: 'estrategias-campania',
                loadComponent: () => import('./visit/estrategias-campania/estrategias-campania.component').then(m => m.EstrategiasCampaniaComponent),
                data: { breadcrumb: 'Estrategias de Campaña: :nombreCliente' },
                children: [
                  {
                    path: 'plantillas-campania',
                    loadComponent: () => import('./visit/estrategias-campania/components/catalogo-plantillas-campanias/catalogo-plantillas-campanias.component').then(m => m.CatalogoPlantillasCampaniasComponent),
                    data: { breadcrumb: 'Plantillas: :nombreCampania' }
                  }
                ]
              }
            ]
          },
        ]
      },
      {
        path: 'catalogos/productos', loadComponent: () => import('./catalogos/productos/lista/productos-nvo-list.component').then(m => m.ProductosNvoListComponent), data: { breadcrumb: 'Productos' }, canActivate: [PermisosGuard], children: [
          { path: 'nuevo', loadComponent: () => import('./catalogos/productos/editar/productos-editar.component').then(m => m.ProductosNvoEditarComponent), data: { breadcrumb: 'Nuevo' } },
          { path: 'editar', loadComponent: () => import('./catalogos/productos/editar/productos-editar.component').then(m => m.ProductosNvoEditarComponent), data: { breadcrumb: 'Editar: :nombreCliente/:nombreProducto' } }
        ]
      },
      {
        path: 'catalogos/conceptos-productos', loadComponent: () => import('./catalogos/conceptos-productos/lista/conceptos-productos-list.component').then(m => m.ConceptosProductosComponent), data: { breadcrumb: 'Conceptos de productos' }, canActivate: [PermisosGuard], children: [
          { path: 'nuevo', loadComponent: () => import('./catalogos/conceptos-productos/nuevo/conceptos-productos.component').then(m => m.ConceptosProductosNvoComponent), data: { breadcrumb: 'Nuevo' } }
        ]
      },
      {
         path: 'catalogos/conceptos-etiquetas-visitas', loadComponent: () => import('./saldos/conceptos-etiquetas-visitas/conceptos-etiquetas-visitas.component').then(m => m.ConceptosEtiquetasVisitasComponent), data: { breadcrumb: 'Conceptos de etiquetas visitas' }, canActivate: [PermisosGuard], children: [
          { path: 'nuevo', loadComponent: () => import('./saldos/conceptos-etiquetas-visitas/conceptos-etiquetas-visitas-form/conceptos-etiquetas-visitas-form.component').then(m => m.ConceptosEtiquetasVisitasFormComponent), data: { breadcrumb: 'Nuevo' } }
        ]
      },
      {
        path: 'catalogos/sucursales', loadComponent: () => import('./catalogos/sucursales/list/sucursales-list.component').then(m => m.SucursalesComponent), data: { breadcrumb: 'Sucursales' }, canActivate: [PermisosGuard], children: [
          { path: 'nuevo', loadComponent: () => import('./catalogos/sucursales/modificar/sucursales-modificar.component').then(m => m.SucursalesModificarComponent), data: { breadcrumb: 'Nuevo' } },
          { path: 'editar', loadComponent: () => import('./catalogos/sucursales/modificar/sucursales-modificar.component').then(m => m.SucursalesModificarComponent), data: { breadcrumb: 'Editar: :nombreCliente/:nombreSucursal' } }
        ]
      },
      {
        path: 'catalogos/criterios-calidad', loadComponent: () => import('./visitas-criterios/criterios-calidad/criterios-calidad.component').then(m => m.CriteriosCalidadComponent), data: { breadcrumb: 'Criterios de Calidad' }, canActivate: [PermisosGuard], children: [
          { path: 'nuevo', loadComponent: () => import('./visitas-criterios/criterios-calidad-nuevo/criterios-calidad-nuevo.component').then(m => m.CriteriosCalidadNuevoComponent), data: { breadcrumb: 'Nuevo' } },
          { path: 'editar', loadComponent: () => import('./visitas-criterios/criterios-calidad-nuevo/criterios-calidad-nuevo.component').then(m => m.CriteriosCalidadNuevoComponent), data: { breadcrumb: 'Editar: :nombreCliente/:nombreProducto' } }
        ]
      },
      {
        path: 'catalogos/tarifas-agentes/lista-tarifa', loadComponent: () => import('./catalogos/tarifas-agentes/lista-tarifa/lista-tarifa.component').then(m => m.ListaTarifaComponent), data: { breadcrumb: 'Tarifas Agentes' }, canActivate: [PermisosGuard], children: [
           { path: 'editar', loadComponent: () => import('./catalogos/tarifas-agentes/editar-tarifa/editar-tarifa.component').then(m => m.TarifaProductosComponent), data: { breadcrumb: 'Editar' } }
        ]
      },
      {
        path: 'catalogos/checklists',
        loadComponent: () => import('./catalogos/checklists/lista/checklists.component').then(m => m.ChecklistsComponent),
        data: { breadcrumb: 'Cuestionarios' },
        canActivate: [PermisosGuard],
        children: [
          {
            path: 'editar',
            loadComponent: () => import('./catalogos/checklists/edicion/checklists-editar.component').then(m => m.ChecklistsEditarComponent),
            data: { breadcrumb: 'Editar: :nombreCliente/:nombreCheckList' }
          },
          {
            path: 'configuracion',
            loadComponent: () => import('./catalogos/checklists/modales/configuracion/config-cuestionario.component').then(m => m.ConfigCuestionarioComponent),
            data: { breadcrumb: 'Configuración: :nombreCliente/:nombreCheckList' }
          },
          {
            path: 'formato-visita',
            loadComponent: () => import('./catalogos/checklists/formato/checklists-formato.component').then(m => m.ChecklistsFormatoComponent),
            data: { breadcrumb: 'Plantillas visitas: :nombreCliente/:nombreCheckList' },
            children: [
              {
                path: 'bloques',
                loadComponent: () => import('./catalogos/checklists/formato/bloques/lista/listado-bloques.component').then(m => m.ListadoBloquesComponent),
                data: { breadcrumb: 'Bloques' },
                children: [
                  {
                    path: 'nuevo',
                    loadComponent: () => import('./catalogos/checklists/formato/bloques/nuevo/bloque-nuevo.component').then(m => m.BloqueNuevoComponent),
                    data: { breadcrumb: 'Nuevo' }
                  },{
                    path: 'editar',
                    loadComponent: () => import('./catalogos/checklists/formato/bloques/nuevo/bloque-nuevo.component').then(m => m.BloqueNuevoComponent),
                    data: { breadcrumb: 'Editar' }
                  }
                ]
              }
            ]
          },
          {
            path: 'formato-cuenta',
            loadComponent: () => import('./catalogos/checklists/formato-cuenta/formato-cuenta.component').then(m => m.FormatoCuentaComponent),
            data: { breadcrumb: 'Plantillas cuentas: :nombreCliente/:nombreCheckList' }
          },
          {
            path: 'plantilla-firma-digital',
            loadComponent: () => import('./catalogos/checklists/plantilla-firma-digital/plantilla-firma-digital.component').then(m => m.PlantillaFirmaDigitalComponent),
            data: { breadcrumb: 'Plantillas firma digital: :nombreCliente/:nombreCheckList' },
            children: [
              {
                path: 'nuevo',
                loadComponent: () => import('./catalogos/checklists/plantilla-firma-digital/form/plantilla-firma-digital-form.component').then(m => m.PlantillaFirmaDigitalFormComponent),
                data: { breadcrumb: 'Nueva plantilla' }
              },
              {
                path: 'editar',
                loadComponent: () => import('./catalogos/checklists/plantilla-firma-digital/form/plantilla-firma-digital-form.component').then(m => m.PlantillaFirmaDigitalFormComponent),
                data: { breadcrumb: 'Editar plantilla' }
              }
            ]
          },
          {
            path: 'layout',
            loadComponent: () => import('src/app/lender/layout-fields/layout-fields.component').then(m => m.LayoutFieldsComponent),
            data: { breadcrumb: 'Layout: :nombreCliente/:nombreCheckList' },
            children: [
              {
                path: 'nuevo',
                loadComponent: () => import('@lender/layout-fields/nuevo/layout-field-nuevo.component').then(m => m.LayoutFieldNuevo),
                data: { breadcrumb: 'Nuevo' }
              }
            ]
          },{
            path: 'estrategias-campania',
            loadComponent: () => import('./visit/estrategias-campania/estrategias-campania.component').then(m => m.EstrategiasCampaniaComponent),
            data: { breadcrumb: 'Estrategias de Campaña: :nombreCliente' },
            children: [
              {
                path: 'plantillas-campania',
                loadComponent: () => import('./visit/estrategias-campania/components/catalogo-plantillas-campanias/catalogo-plantillas-campanias.component').then(m => m.CatalogoPlantillasCampaniasComponent),
                data: { breadcrumb: 'Plantillas: :nombreCampania' }
              }
            ]
          }
        ]
      }, {
        path: 'importacion', loadComponent: () => import('./import/home/home.component').then(m => m.HomeComponent), data: { breadcrumb: 'Importaciones' }, canActivate: [PermisosGuard], children: [
          { path: 'asistente/:idCliente/:idFinanciera', loadComponent: () => import('./import/wizard/wizard.component').then(m => m.WizardComponent), data: { breadcrumb: 'Proceso' } },
          { path: 'cuentas-nuevas/:idCliente', loadComponent: () => import('./account/new/new-account.component').then(m => m.NewAccountComponent), data: { breadcrumb: 'Nueva cuenta' } },
          {
            path: 'archivos-masivos/:idCliente/:idFinanciera',
            data: { breadcrumb: 'Carga masiva de archivos' },
            children: [
              {
                path: '',
                loadComponent: () => import(
                  './import/archivos-masivos/archivos-masivos-historial.component'
                ).then(m => m.ArchivosMasivosHistorialComponent),
                // RN: path vacío hereda data del padre; sin esto el crumb se duplica.
                data: { breadcrumb: null }
              },
              {
                path: 'nueva',
                loadComponent: () => import(
                  './import/archivos-masivos/archivos-masivos-wizard.component'
                ).then(m => m.ArchivosMasivosWizardComponent),
                data: { breadcrumb: 'Nueva carga' }
              },
              {
                path: 'lote/:idLote',
                loadComponent: () => import(
                  './import/archivos-masivos/archivos-masivos-detalle.component'
                ).then(m => m.ArchivosMasivosDetalleComponent),
                data: { breadcrumb: 'Detalle' }
              }
            ]
          },
          { path: ':idImportacion', loadComponent: () => import('./import/finish/finish.component').then(m => m.FinishComponent), data: { breadcrumb: 'importación' } },
        ]
      },
      {
        path: 'catalogos/administradores', loadComponent: () => import('./catalogos/usuarios/usuarios.component').then(m => m.UsuariosComponent), data: { breadcrumb: 'Administradores' }, canActivate: [PermisosGuard], children: [
          { path: 'nuevo', loadComponent: () => import('./catalogos/usuarios/usuarios-form/usuarios-form.component').then(m => m.UsuariosFormComponent), data: { breadcrumb: 'Nuevo' } },
          { path: 'editar', loadComponent: () => import('./catalogos/usuarios/usuarios-form/usuarios-form.component').then(m => m.UsuariosFormComponent), data: { breadcrumb: 'Edición' } },
          { path: 'editar-sucursal', loadComponent: () => import('./catalogos/usuarios/sucursales/sucursales-modificar.component').then(m => m.AdmistradorSucursalesModificarComponent), data: { breadcrumb: 'Edición: :nombreAdmin' } },
          { path: 'editar-producto', loadComponent: () => import('./catalogos/usuarios/productos/productos-modificar.component').then(m => m.AdmistradorProductosModificarComponent), data: { breadcrumb: 'Edición: :nombreAdmin' } }
        ]
      },
      {
        path: 'catalogos/tutoriales', loadComponent: () => import('./catalogos/tutoriales/tutoriales.component').then(m => m.TutorialesComponent), data: { breadcrumb: 'Tutoriales' }, canActivate: [PermisosGuard], children: [
          { path: 'nuevo', loadComponent: () => import('./catalogos/tutoriales/tutoriales-editar/tutoriales-editar.component').then(m => m.TutorialesEditarComponent), data: { breadcrumb: 'Nuevo' } },
          { path: 'editar', loadComponent: () => import('./catalogos/tutoriales/tutoriales-editar/tutoriales-editar.component').then(m => m.TutorialesEditarComponent), data: { breadcrumb: 'Editar' } }
        ]
      },
      {
        path: 'catalogos/etiquetas-visitas', loadComponent: () => import('./catalogos/etiquetas-visitas/lista/etiquetas-visitas.component').then(m => m.CatalogoEtiquetasVisitasComponent), data: { breadcrumb: 'Etiquetas de visitas' }, canActivate: [PermisosGuard], children: [
          { path: 'form', loadComponent: () => import('./catalogos/etiquetas-visitas/etiquetas-visitas-form/etiquetas-visitas-form.component').then(m => m.EtiquetasVisitasFormComponent), data: { breadcrumb: 'Nuevo' } }
        ]
      },
      {
        path: 'catalogos/clientes-etiquetas-visitas', loadComponent: () => import('./catalogos/clientes-etiquetas-visitas/lista/clientes-etiquetas-visitas.component').then(m => m.ClientesEtiquetasVisitasComponent), data: { breadcrumb: 'Etiquetas de visitas clientes' }, canActivate: [PermisosGuard], children: [
          { path: 'form', loadComponent: () => import('./catalogos/clientes-etiquetas-visitas/form/clientes-etiquetas-visitas-form.component').then(m => m.ClientesEtiquetasVisitasFormComponent), data: { breadcrumb: 'Asignar' } }
        ]
      },
      /*{
        path: 'accounts', loadComponent: () => import('./account/account-list.component').then(m => m.AccountListComponent), data: { breadcrumb: 'Cuentas' }, children: [
          //{ path: 'account/:id', loadComponent: () => import('./account/account-detail.component').then(m => m.AccountDetailComponent), data:{breadcrumb: 'Detalle'} },
          { path: 'account', loadComponent: () => import('./account/account-detail.component').then(m => m.AccountDetailComponent), data: { breadcrumb: 'Detalle', animation: 'routeAnimations' } }
        ]
      },*/
      {
        path: 'cuentas/domicilios', loadComponent: () => import('./account/account-list.component').then(m => m.AccountListComponent), data: { breadcrumb: 'Cuentas - Domicilios' }, canActivate: [PermisosGuard], children: [
          { path: 'account', loadComponent: () => import('./account/account-detail.component').then(m => m.AccountDetailComponent), data: { breadcrumb: 'Detalle', animation: 'routeAnimations' } }
        ]
      },
      {
        path: 'cuentas/principales', loadComponent: () => import('./cuentas/cuentas-agrupadas/cuentas-agrupadas-list.component').then(m => m.CuentasAgrupadasListComponent), data: { breadcrumb: 'Cuentas - Principales' }, canActivate: [PermisosGuard], children: [
          { path: 'account', loadComponent: () => import('./account/account-detail.component').then(m => m.AccountDetailComponent), data: { breadcrumb: 'Detalle', animation: 'routeAnimations' } }
        ]
      },
      {
        path: 'cuentas/campañas', loadComponent: () => import('./cuentas/cuentas-campañas/cuentas-campaigns.component').then(m => m.CuentasCampaignsComponent), data: { breadcrumb: 'Cuentas - Campañas' }, canActivate: [PermisosGuard], children: [
          { path: 'account', loadComponent: () => import('./account/account-detail.component').then(m => m.AccountDetailComponent), data: { breadcrumb: 'Detalle', animation: 'routeAnimations' } }
        ]
      },
      {
        path: 'cuentas/citas', loadComponent: () => import('./account/account-list.component').then(m => m.AccountListComponent), data: { breadcrumb: 'Cuentas - Citas', esVistaCitas: true }, canActivate: [PermisosGuard], children: [
          { path: 'account', loadComponent: () => import('./account/account-detail.component').then(m => m.AccountDetailComponent), data: { breadcrumb: 'Detalle', animation: 'routeAnimations' } }
        ]
      },
      {
        path: 'seguimiento-integral',
        loadComponent: () => import('./cuentas/seguimiento-integral/seguimiento-integral.component').then(m => m.SeguimientoIntegralComponent),
        data: { breadcrumb: 'Seguimiento Integral de Cuentas' },
        canActivate: [PermisosGuard],
        children: [
          {
            path: 'agentes/:id', loadComponent: () => import('./agent/agent-detail/agent-detail.component').then(m => m.AgentDetailComponent), data: { breadcrumb: 'Agente: :id', animation: 'routeAnimations' }
          }
        ]
      },
      {
        path: 'esquema-pago-agentes',
        loadComponent: () => import('./esquema-pago-agentes/esquema-pago-agentes.component').then(m => m.EsquemaPagoAgentesComponent),
        data: { breadcrumb: 'Esquema Pago Agentes 3.0' },
        canActivate: [PermisosGuard],
        children: [
          {
            path: 'agentes/:id',
            loadComponent: () => import('./agent/agent-detail/agent-detail.component').then(m => m.AgentDetailComponent),
            data: { breadcrumb: 'Agente: :id', animation: 'routeAnimations' },
          },
        ],
      },
      {
        path: 'cobertura',
        loadComponent: () => import('./cobertura/mapa-cobertura/mapa-cobertura.component').then(m => m.MapaCoberturaComponent),
        data: { breadcrumb: 'Cobertura' },
        canActivate: [PermisosGuard],
      },
      {
        path: 'clientes-movimientos', loadComponent: () => import('./saldos/clientes-movimientos/clientes-movimientos.component').then(m => m.ClientesMovimientosComponent), data: { breadcrumb: 'Movimientos clientes' }, canActivate: [PermisosGuard], children: [
          {
            path: 'form', loadComponent: () => import('./saldos/clientes-movimientos/clientes-movimientos-form/clientes-movimientos-form.component').then(m => m.ClientesMovimientosFormComponent), data: { breadcrumb: 'Nuevo' }, children: [
              //que no se nos olvide descomentar esto por que a un no esta la opcion  agregada
              { path: 'conceptos', loadComponent: () => import('./saldos/conceptos-saldos/conceptos-saldos-form/conceptos-saldos-form.component').then(m => m.ConceptosSaldosFormComponent), data: { breadcrumb: 'Concepto' } }
            ]
          }
        ]
      },
      {
        path: 'gestores-movimientos', loadComponent: () => import('./saldos/cobradores-movimientos/cobradores-movimientos.component').then(m => m.CobradoresMovimientosComponent), data: { breadcrumb: 'Movimientos Agentes' }, canActivate: [PermisosGuard], children: [
          {
            path: 'form', loadComponent: () => import('./saldos/cobradores-movimientos/cobradores-movimientos-form/cobradores-movimientos-form.component').then(m => m.CobradoresMovimientosFormComponent), data: { breadcrumb: 'Nuevo' },
            children: [
              { path: 'periodos', loadComponent: () => import('./saldos/cobradores-facturaciones-periodos/cobradores-facturaciones-periodos-form/cobradores-facturaciones-periodos-form.component').then(m => m.CobradoresFacturacionesPeriodosFormComponent), data: { breadcrumb: 'Periodo' } },
              { path: 'conceptos', loadComponent: () => import('./saldos/conceptos-saldos/conceptos-saldos-form/conceptos-saldos-form.component').then(m => m.ConceptosSaldosFormComponent), data: { breadcrumb: 'Concepto' } }
            ]
          }
        ]
      },
      {
        path: 'saldos/mov-ajustes-ejecutivo', loadComponent: () => import('./saldos/ajuste-movimiento-agentes/ajuste-movimiento-agentes.component').then(m => m.AjusteMovimientoAgentesComponent), data: { breadcrumb: 'Movimientos Agentes (Ejecutivos 360)' }, canActivate: [PermisosGuard], children: [
          {
            path: 'nuevo', loadComponent: () => import('./saldos/ajuste-movimiento-agentes/ajuste-movimiento-agentes-nuevo/ajuste-movimiento-agentes-nuevo.component').then(m => m.AjusteMovimientoAgentesNuevoComponent), data: { breadcrumb: 'Nuevo' },
            children: [
              // { path: 'periodos', loadComponent: () => import('./saldos/cobradores-facturaciones-periodos/cobradores-facturaciones-periodos-form/cobradores-facturaciones-periodos-form.component').then(m => m.CobradoresFacturacionesPeriodosFormComponent), data: { breadcrumb: 'Periodo' } },
              // { path: 'conceptos', loadComponent: () => import('./saldos/conceptos-saldos/conceptos-saldos-form/conceptos-saldos-form.component').then(m => m.ConceptosSaldosFormComponent), data: { breadcrumb: 'Concepto' } }
            ]
          }
        ]
      },
      {
        path: 'catalogos/permisos-producto', loadComponent: () => import('./catalogos/permisos-producto/lista/productos-list.component').then(m => m.ProductosComponent), data: { breadcrumb: 'Permisos por producto' }, canActivate: [PermisosGuard], children: [
          {
            path: 'editar', loadComponent: () => import('./catalogos/permisos-producto/editar/productos-modificar.component').then(m => m.ProductosModificarComponent), data: { breadcrumb: 'Editar: :nombreCliente/:nombreProducto' }
          }
        ]
      },
      {
        path: 'catalogos/paquetes', loadComponent: () => import('./catalogos/paquetes-saldos/paquetes-saldos.component').then(m => m.PaquetesSaldosComponent), data: { breadcrumb: 'Paquetes' }, canActivate: [PermisosGuard], children: [
          { path: 'nuevo', loadComponent: () => import('./catalogos/paquetes-saldos-conceptos/paquetes-saldos-conceptos.component').then(m => m.PaquetesSaldosConceptosComponent), data: { breadcrumb: 'Nuevo' } },
          { path: 'editar', loadComponent: () => import('./catalogos/paquetes-saldos-conceptos/paquetes-saldos-conceptos.component').then(m => m.PaquetesSaldosConceptosComponent), data: { breadcrumb: 'editar' } }
        ]
      },
      {
        path: 'conceptos', loadComponent: () => import('./saldos/conceptos-saldos/conceptos-saldos.component').then(m => m.ConceptosSaldosComponent), data: { breadcrumb: 'Conceptos' }, canActivate: [PermisosGuard], children: [
          { path: 'nuevo', loadComponent: () => import('./saldos/conceptos-saldos/conceptos-saldos-form/conceptos-saldos-form.component').then(m => m.ConceptosSaldosFormComponent), data: { breadcrumb: 'Nuevo' } },
          { path: 'editar', loadComponent: () => import('./saldos/conceptos-saldos/conceptos-saldos-form/conceptos-saldos-form.component').then(m => m.ConceptosSaldosFormComponent), data: { breadcrumb: 'Editar' } },
        ]
      },
      {
        path: 'cobradores-facturaciones-periodos', loadComponent: () => import('./saldos/cobradores-facturaciones-periodos/cobradores-facturaciones-periodos.component').then(m => m.CobradoresFacturacionesPeriodosComponent), data: { breadcrumb: 'Periodos de facturación' }, canActivate: [PermisosGuard], children: [
          { path: 'nuevo', loadComponent: () => import('./saldos/cobradores-facturaciones-periodos/cobradores-facturaciones-periodos-form/cobradores-facturaciones-periodos-form.component').then(m => m.CobradoresFacturacionesPeriodosFormComponent), data: { breadcrumb: 'Nuevo' } },
          { path: 'editar', loadComponent: () => import('./saldos/cobradores-facturaciones-periodos/cobradores-facturaciones-periodos-form/cobradores-facturaciones-periodos-form.component').then(m => m.CobradoresFacturacionesPeriodosFormComponent), data: { breadcrumb: 'Editar' } }
        ]
      },
      {
        path: 'paquetes-cliente',
        loadComponent: () => import('./saldos/paquetes-financiera/paquetes-financiera.component').then(m => m.PaquetesFinancieraComponent),
        data: { breadcrumb: 'Paquetes cliente' },
        canActivate: [PermisosGuard],
        children: [
          {
            path: 'configuracion',  // Ruta estática primero
            loadComponent: () => import('./saldos/paquetes-financiera/configuration/configuration.component').then(m => m.PaquetesClientesConfigurationComponent),
            data: { breadcrumb: 'Configuraciones' }
          },
          {
            path: ':idFinanciera',
            loadComponent: () => import('./lender/detail/detail.component').then(m => m.LenderDetailComponent),
            data: { breadcrumb: 'Editar' },
            children: [
              {
                path: 'paquetes/:idFinancieraPaquete',
                loadComponent: () => import('./saldos/paquetes-financiera/paquetes-financiera-detalle/paquetes-financiera-detalle.component').then(m => m.PaquetesFinancieraDetalleComponent),
                data: { breadcrumb: 'Conceptos' }
              }
            ]
          },
          {
            path: ':idFinanciera/centros-costos',
            loadComponent: () => import('./saldos/paquetes-financiera/centros-costos/centros-costos.component').then(m => m.CentrosCostosComponent),
            data: { breadcrumb: 'Centros de Costos por Cliente' }
          }
        ]
      }, {
        path: 'visits',
        loadComponent: () => import('./visit/visit-list.component').then(m => m.VisitListComponent),
        data: { breadcrumb: 'Visitas' },
        canActivate: [PermisosGuard],
        children: [
          {
            path: 'visit/:folio',
            loadComponent: () => import('./visit/visit-detail.component').then(m => m.VisitDetailComponent),
            data: { breadcrumb: ':folio' },
          }, {
            path: 'create',
            loadComponent: () => import('./visit-create/visit-create.component').then(m => m.VisitCreateComponent),
            data: { breadcrumb: 'Generar visita' },
          }
        ]
      },       {
        path: 'agentes', loadComponent: () => import('./agent/agent-list/agent-list.component').then(m => m.AgentListComponent), data: { breadcrumb: 'Agentes' }, canActivate: [PermisosGuard], children: [
          { path: 'nuevo', loadComponent: () => import('@agent/agente-nuevo/agente-nuevo.component').then(m => m.AgenteNuevoComponent), data: { breadcrumb: 'Nuevo' } },
          {
            path: ':id', loadComponent: () => import('./agent/agent-detail/agent-detail.component').then(m => m.AgentDetailComponent), data: { breadcrumb: 'Agente: :id' }, children: [
              { path: 'recorrido-hoy', loadComponent: () => import('./agent/agente-recorridos/agente-recorrido.component').then(m => m.AgenteRecorridoComponent), data: { breadcrumb: 'Recorrido de hoy' } }
            ]
          }
        ]
      },
      { path: 'agentes-visibilidad', loadComponent: () => import('./agent/visibilidad-cuentas/lista/lista-visibilidad.component').then(m => m.ListaVisibilidadComponent), data: { breadcrumb: 'Visibilidad de cuentas' }, canActivate: [PermisosGuard], children: [
        { path: 'cuenta', loadComponent: () => import('./account/account-detail.component').then(m => m.AccountDetailComponent), data: { breadcrumb: 'Detalle', animation: 'routeAnimations' } }
      ]},
      { path: 'agentes-recorrido', loadComponent: () => import('./agent/agente-recorridos/agente-recorrido.component').then(m => m.AgenteRecorridoComponent), data: { breadcrumb: 'Recorrido por agente' }, canActivate: [PermisosGuard] },
      { path: 'agentes-ubicacion', loadComponent: () => import('./agent/agente-ubicacion/agente-ubicacion.component').then(m => m.AgenteUbicacionComponent), data: { breadcrumb: 'Ubicación de agentes' }, canActivate: [PermisosGuard], children: [
        { path: 'recorrido-hoy', loadComponent: () => import('./agent/agente-recorridos/agente-recorrido.component').then(m => m.AgenteRecorridoComponent), data: { breadcrumb: 'Recorrido de hoy' } }
      ] },
      {
        path: 'deallocation-percentage',
        loadComponent: () => import('./indicators/indicators.component').then(m => m.IndicatorsComponent),
        data: { breadcrumb: 'Porcentaje de desasignación' },
        canActivate: [PermisosGuard]
      },       {
        path: 'calificar-obligatorios', loadComponent: () => import('./calificar-obligatorios/calificar-obligatorios.component').then(m => m.CalificarObligatoriosComponent), data: { breadcrumb: 'Calificar Obligatorias (Red Kobra)' }, canActivate: [PermisosGuard], children: [
          {
            path: 'visit/:id', loadComponent: () => import('./visit/visit-detail.component').then(m => m.VisitDetailComponent), data: { breadcrumb: 'Visita: :id', animation: 'routeAnimations' }
          },
          {
            path: 'cuenta', loadComponent: () => import('./account/account-detail.component').then(m => m.AccountDetailComponent), data: { breadcrumb: 'Detalle', animation: 'routeAnimations' }
          }
        ]
      },
      {
        path: 'promesas-pago', loadComponent: () => import('./promesas-pago/promesas-pago.component').then(m => m.PromesasPagoComponent), data: { breadcrumb: 'Promesas de pago' }, canActivate: [PermisosGuard], children: [
          {
            path: 'visit/:id', loadComponent: () => import('./visit/visit-detail.component').then(m => m.VisitDetailComponent), data: { breadcrumb: 'Visita: :id', animation: 'routeAnimations' }
          },
          {
            path: 'cuenta', loadComponent: () => import('./account/account-detail.component').then(m => m.AccountDetailComponent), data: { breadcrumb: 'Detalle', animation: 'routeAnimations' }
          },
          {
            path: 'agentes/:id', loadComponent: () => import('./agent/agent-detail/agent-detail.component').then(m => m.AgentDetailComponent), data: { breadcrumb: 'Agente: :id', animation: 'routeAnimations' }
          }

        ]
      }, {
        path: 'cash-collected', loadComponent: () => import('./cash-collected/cash-collected.component').then(m => m.CashCollectedComponent), data: { breadcrumb: 'Cash Collected' }, canActivate: [PermisosGuard], children: [
          {
            path: 'visit/:id', loadComponent: () => import('./visit/visit-detail.component').then(m => m.VisitDetailComponent), data: { breadcrumb: 'Visita: :id', animation: 'routeAnimations' }
          },
          {
            path: 'cuenta', loadComponent: () => import('./account/account-detail.component').then(m => m.AccountDetailComponent), data: { breadcrumb: 'Detalle ', animation: 'routeAnimations' }
          },
          {
            path: 'agentes/:id', loadComponent: () => import('./agent/agent-detail/agent-detail.component').then(m => m.AgentDetailComponent), data: { breadcrumb: 'Agente: :id', animation: 'routeAnimations' }
          }
        ]
      }, {
        path: 'informacion-recopilada',
        loadComponent: () => import('./visit/informacion-recopilada/informacion-recopilada.component').then(m => m.InformacionRecopiladaComponent),
        data: { breadcrumb: 'Información recopilada' },
        canActivate: [PermisosGuard],
        children: [
          {
            path: 'cuenta', loadComponent: () => import('./account/account-detail.component').then(m => m.AccountDetailComponent), data: { breadcrumb: 'Detalle', animation: 'routeAnimations' }
          },
          {
            path: 'agentes/:id', loadComponent: () => import('./agent/agent-detail/agent-detail.component').then(m => m.AgentDetailComponent), data: { breadcrumb: 'Agente: :id',animation: 'routeAnimations' }, children: [
              { path: 'recorrido-hoy', loadComponent: () => import('./agent/agente-recorridos/agente-recorrido.component').then(m => m.AgenteRecorridoComponent), data: { breadcrumb: 'Recorrido de hoy',animation: 'routeAnimations' } }
            ]
          }
        ]
      }, {
        path: 'revisit-request',
        loadComponent: () => import('./visit/revisita/revisita-lista.component').then(m => m.RevisitListComponent),
        data: { breadcrumb: 'Solicitudes de revisita' },
        canActivate: [PermisosGuard],
        children: [
          {
            path: 'visit/:folio', loadComponent: () => import('./visit/visit-detail.component').then(m => m.VisitDetailComponent), data: { breadcrumb: 'Visita: :folio', animation: 'routeAnimations'  }
          },
          {
            path: 'cuenta', loadComponent: () => import('./account/account-detail.component').then(m => m.AccountDetailComponent), data: { breadcrumb: 'Detalle', animation: 'routeAnimations' }
          },
          {
            path: 'agentes/:id', loadComponent: () => import('./agent/agent-detail/agent-detail.component').then(m => m.AgentDetailComponent), data: { breadcrumb: 'Agente: :id', animation: 'routeAnimations' }
          }
        ]
      }, {
        path: 'requests',
        loadComponent: () => import('./credit-request/request-list.component').then(m => m.RequestListComponent),
        data: { breadcrumb: 'Solicitudes' },
        canActivate: [PermisosGuard],
        children: [{
          path: ':id/cliente/:idFinanciera',
          loadComponent: () => import('./credit-request/credit-request.component').then(m => m.CreditRequestComponent),
          data:{breadcrumb: 'Detalle de solicitud: :id'}},
        ]
      }, {
        path: 'gestores-facturaciones',
        loadComponent: () => import('./saldos/cobradores-facturaciones/cobradores-facturaciones.component').then(m => m.CobradoresFacturacionesComponent),
        data: { breadcrumb: 'Facturaciones Agentes' },
        canActivate: [PermisosGuard],
        children: [
          {
            path: 'agentes/:id', loadComponent: () => import('./agent/agent-detail/agent-detail.component').then(m => m.AgentDetailComponent), data: { breadcrumb: 'Agente: :id', animation: 'routeAnimations' }
          }
        ]
      }, {
        path: 'visitas-calificadas', loadComponent: () => import('./calificadas-visitas/calificadas-visitas.component').then(m => m.CalificadasVisitasComponent), data: { breadcrumb: 'Visitas Calificadas' }, canActivate: [PermisosGuard], children: [
          {
            path: 'visit/:folio', loadComponent: () => import('./visit/visit-detail.component').then(m => m.VisitDetailComponent), data: { breadcrumb: 'Visita: :folio' }, children: [
            ]
          },{
            path: 'agentes/:id', loadComponent: () => import('./agent/agent-detail/agent-detail.component').then(m => m.AgentDetailComponent), data: { breadcrumb: 'Agente: :id', animation: 'routeAnimations' }
          }
        ]
      },
      {
        path: 'descargas',
        loadComponent: () => import('./descargas/descargas.component').then(m => m.DescargasComponent),
        data: { breadcrumb: 'Descargas' },
        canActivate: [PermisosGuard]
    },
    {
        path: 'auditoria/acciones',
        loadComponent: () => import('./auditoria/acciones/auditoria-acciones.component')
          .then(m => m.AuditoriaAccionesComponent),
        data: { breadcrumb: 'Acciones de usuarios' },
        canActivate: [PermisosGuard]
    },
    {
        path: 'auditoria/precalificaciones',
        loadComponent: () =>
          import('./auditoria/precalificaciones/auditoria-precalificaciones.component')
            .then(m => m.AuditoriaPrecalificacionesComponent),
        data: { breadcrumb: 'Precalificaciones' },
        canActivate: [PermisosGuard]
    },
    {
        path: 'user',
        loadComponent: () => import('./user/edit/user-edit.component').then(m => m.UserEditComponent) ,
        data: { breadcrumb: 'Editar Perfil' }
      },

    ]
  },
  { path: '**', redirectTo: '/' }

];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {
        enableTracing: false,
        // Precarga todos los chunks lazy en segundo plano tras el arranque:
        // el bundle inicial se mantiene chico, pero al hacer clic en el menu
        // la ruta ya esta descargada y el resaltado (routerLinkActive) es
        // inmediato, como en la version eager anterior.
        preloadingStrategy: PreloadAllModules
      }
    ),
    BrowserAnimationsModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
